import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button } from 'molecules';
import { useSelector } from 'react-redux';
import depositRoutes from 'app/depositFlow/routes';

const GameButtons = props => {
  const user = useSelector(state => state.currentUser.currentUser);
  const history = useHistory();
  const [hasLink, setHasLink] = useState(false);

  useEffect(() => {
    props.Links.map((link, i) => {
      link.showLink = false;
      if(window.location.pathname.indexOf('/spil-for-sjov/') > -1 ) {
        if(link.Styling.indexOf('o-gameoverview__link--play-for-money') > -1) {
          link.onClick = playForMoney;
          link.showLink = true;
          setHasLink(true);
        }
      } else if(window.location.pathname.indexOf('/pengespil/') > -1 ) {
        if(user.isAuthenticated && link.Styling.indexOf('o-gameoverview__link--payment') > -1) {
          link.showLink = true;
          setHasLink(true);
          link.onClick = goToDeposit;
        } else if(!user.isAuthenticated) {
          link.onClick = playForMoney;
          link.showLink = true;
          setHasLink(true);
        }
      }
      return link;
    });
  }, [hasLink]);

  const goToDeposit = () => {
    history.push(depositRoutes.deposit.url);
  };

  const playForMoney = () => {
    let location = window.location.pathname;
    location = location.replace('spil-for-sjov', 'pengespil');
    window.location.href = `${location}`;
  };

  return (
    <div className={'o-game-overview__buttons'}>
      { props.Links.map((link, index) => {
        if(!link.showLink) {
          return;
        }
        return <Button onClick={link.onClick} key={index}>{link.LinkText}</Button>;
      }
      )}
    </div>
  );
};

GameButtons.propTypes = {
  Links: PropTypes.array
};

GameButtons.defaultProps = {
  Links: []
};

export default GameButtons;